// @ts-strict-ignore
import { combineReducers } from 'redux';
import { TryUpdateStepRunsAction, UPDATE_STEP_RUNS } from '@/actions/stepRun';
import { StepRun } from '@/types/stepRun';

interface StepRunsById {
    [id: string]: StepRun;
}

type StepRunActionTypes = TryUpdateStepRunsAction;

function stepRunsById(state: StepRunsById = {}, action: StepRunActionTypes) {
    switch (action.type) {
        case UPDATE_STEP_RUNS: {
            const newState = {
                ...state,
            };
            const stepRuns = action.payload;
            for (const stepRun of stepRuns) {
                newState[stepRun.id] = stepRun;
            }
            return newState;
        }

        default:
            return state;
    }
}

export const stepRunsReducer = combineReducers({
    byId: stepRunsById,
});
